import { getConfigEntryByKey } from '@/modules/global-settings/facades/get-config-entry-by-key';

export function getPayCenterConfiguration(params) {
  function isMPC(params) {
    // Determine if multi pay centers is enabled
    // In enterprise, it has this feature enabled by default, without the need of a configuration
    return getConfigEntryByKey('PayCentresEnabled') === '1';
  }

  function isMultiPayDetailsEnabled() {
    // Determine if multi pay details is enabled
    return getConfigEntryByKey('MultiplePayDetailsEnabled') === '1';
  }

  function isOneProduct(params) {
    // Determines if the One Product feature is enabled
    // This value is defined in DeputecHashTable, not DeputecConfigEntry, but it's still a configuration
    return getConfigEntryByKey('OneProduct') === '1';
  }

  function isMPCAvailableOnPremium() {
    return isOneProduct() && isMPC();
  }

  function isOnlyMPCAvailableOnPremium() {
    return isOneProduct() && isMPC() && !isMultiPayDetailsEnabled();
  }

  function isMultiPayDetailsAvailableOnPremium() {
    return isOneProduct() && isMultiPayDetailsEnabled();
  }

  return {
    isMPC,
    isMultiPayDetailsEnabled,
    isMPCAvailableOnPremium,
    isMultiPayDetailsAvailableOnPremium,
    isOneProduct,
    isOnlyMPCAvailableOnPremium,
  };
}
